import { Doc } from '@/convex/_generated/dataModel';

/**
 * Gets today's date in YYYY-MM-DD format.
 * This format matches the dueAt field format in the database.
 */
export function getTodayFormatted(): string {
  return new Date().toISOString().split('T')[0];
}

/**
 * Checks if a task is a "vanilla" task.
 * A vanilla task is a basic task without any special properties:
 * - No category
 * - No priority
 * - No project
 * - No due date
 * - No recurring template
 */
export function isVanillaTask(task: Doc<'normalTasks'>): boolean {
  return !task.categoryId &&
         !task.priority &&
         !task.projectId &&
         !task.dueAt &&
         !task.recurringTaskTemplateId;
}

/**
 * Checks if a task was completed today.
 * Returns false if the task is not completed or has no completion timestamp.
 */
export function wasCompletedToday(task: Doc<'normalTasks'>): boolean {
  if (!task.completed || !task.completedAt) return false;
  
  const today = getTodayFormatted();
  const completedDate = new Date(task.completedAt).toISOString().split('T')[0];
  
  return completedDate === today;
}

/**
 * Checks if a task is overdue.
 * A task is overdue if:
 * - It has a due date
 * - The due date is before today
 * - The task is not completed
 */
export function isOverdue(task: Doc<'normalTasks'>): boolean {
  if (!task.dueAt || task.completed) return false;
  
  const today = getTodayFormatted();
  return task.dueAt < today;
}

/**
 * Checks if a task is due today.
 * Returns false if the task has no due date.
 */
export function isDueToday(task: Doc<'normalTasks'>): boolean {
  if (!task.dueAt) return false;
  
  const today = getTodayFormatted();
  return task.dueAt === today;
}